<section hlmCard class="login-card">
  <div hlmCardContent>
    <div class="login-card__content">
      <h1 class="login-card__title">{{ 'login-form.welcome-to-ocp' | translate }}</h1>
      <ocp-themed-icon name="auth-image.svg" width="184" height="124" />
      <h2 class="login-card__subtitle">
        {{ 'login-form.connect-tools-data-and-people-to-collaborate-seamlessly' | translate }}
      </h2>
    </div>

    <div class="login-card__actions">
      <button hlmBtn (click)="login.emit()">{{ 'login-form.sign-in' | translate }}</button>
      @if (showCreateAccount()) {
        <button hlmBtn variant="secondary" (click)="createAccount.emit()">
          {{ 'login-form.create-account' | translate }}
        </button>
      }
    </div>
  </div>
</section>
